<template>
  <router-view />
</template>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
@import 'sweetalert2/src/sweetalert2.scss';
</style>
<style lang="css">

.v-popper--theme-menu-oscuro .v-popper__inner {
  background-color: #2c3e50; /* Fondo oscuro */
  color: #ecf0f1; /* Texto claro */
  border-radius: 4px;
  padding: 0; /* Sin padding en el contenedor principal para que lo tenga la lista */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
}

/* Ocultar la flecha si no la quieres */
.v-popper--theme-menu-oscuro .v-popper__arrow-container {
  display: none;
}

/* Estilo para los elementos de la lista dentro del dropdown */
.v-popper--theme-menu-oscuro ul {
  list-style: none;
  padding: 5px 0;
  margin: 0;
}

.v-popper--theme-menu-oscuro li {
  padding: 8px 15px;
  cursor: pointer;
}

.v-popper--theme-menu-oscuro li:hover {
  background-color: #34495e; /* Cambio de color al pasar el ratón */
}
</style>

<style src="@vueform/multiselect/themes/default.css"></style>